import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  CurrentUserService,
  UserNotificationService,
} from '@frontend/common/src/lib/util';
import { DepartmentSelectorComponent } from './department-selector.component';

@Component({
  selector: 'wrt-routed-create',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CurrentUserService, UserNotificationService],
  standalone: false
})
export class RoutedDepartmentSelectorComponent implements AfterViewInit {
  private dialogRef: MatDialogRef<DepartmentSelectorComponent> | null = null;

  constructor(private dialog: MatDialog) {}

  ngAfterViewInit(): void {
    this._openDialog();
  }

  _openDialog() {
    if (this.dialogRef && this.dialogRef.componentInstance) {
      return;
    }

    const openDialogs = this.dialog.openDialogs;
    const existingDialog = openDialogs.find(
      (ref) => ref.componentInstance instanceof DepartmentSelectorComponent
    );
    if (existingDialog) {
      return;
    }

    this.dialogRef = this.dialog.open(DepartmentSelectorComponent, {
      width: '500px',
      panelClass: ['no-padding'],
      disableClose: true,
      closeOnNavigation: false,
      autoFocus: true,
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
